/**
 * M1 — shared analytics for Temple of Light (reads window.__ENV__).
 */
const DEFAULT_EVENTS = {
  pageView: "page_view",
  ctaBookClick: "cta_book_click",
  ctaInnerVoiceClick: "cta_innervoice_click",
  ctaOrasisStagingClick: "cta_orasis_staging_click",
  orasisCheckoutStart: "orasis_checkout_start",
  checkoutStart: "checkout_start",
  purchase: "purchase",
};

function readConfig() {
  const env = window.__ENV__ || {};
  const ga4 = String(env.REACT_APP_GA4_MEASUREMENT_ID || "").trim();
  const metaPixel = String(env.REACT_APP_META_PIXEL_ID || "").trim();
  const enabled = env.REACT_APP_ANALYTICS_ENABLED !== "false" && (!!ga4 || !!metaPixel);
  const debug = env.REACT_APP_ANALYTICS_DEBUG === "true";
  return { enabled, ga4, metaPixel, debug, events: DEFAULT_EVENTS };
}

let ready = false;
let cfg = readConfig();

function log(...args) {
  if (!cfg.debug) return;
  console.info("[NBF Analytics]", ...args);
}

function loadScript(src) {
  return new Promise((resolve, reject) => {
    const el = document.createElement("script");
    el.async = true;
    el.src = src;
    el.onload = () => resolve();
    el.onerror = () => reject(new Error(`script load failed: ${src}`));
    document.head.appendChild(el);
  });
}

export async function bootAnalytics() {
  if (ready) return;
  cfg = readConfig();
  if (!cfg.enabled) {
    log("disabled");
    ready = true;
    return;
  }
  try {
    if (cfg.ga4) {
      await loadScript(`https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(cfg.ga4)}`);
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
      window.gtag("js", new Date());
      window.gtag("config", cfg.ga4, { send_page_view: false });
      log("GA4 ready", cfg.ga4);
    }
    if (cfg.metaPixel) {
      (function (f, b, e, v, n, t, s) {
        if (f.fbq) return;
        n = f.fbq = function () {
          n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
        };
        if (!f._fbq) f._fbq = n;
        n.push = n;
        n.loaded = true;
        n.version = "2.0";
        n.queue = [];
        t = b.createElement(e);
        t.async = true;
        t.src = v;
        s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s);
      })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
      window.fbq("init", cfg.metaPixel);
      log("Meta Pixel ready", cfg.metaPixel);
    }
  } catch (err) {
    log("boot error", err?.message || err);
  }
  ready = true;
}

export function trackEvent(eventName, params = {}) {
  log("track", eventName, params);
  if (window.gtag) window.gtag("event", eventName, params);
  if (window.fbq) window.fbq("trackCustom", eventName, params);
}

export function trackPageView(extra = {}) {
  const payload = {
    page_title: document.title,
    page_location: window.location.href,
    page_path: window.location.pathname + window.location.search,
    ...extra,
  };
  log("pageView", payload);
  if (window.gtag) window.gtag("event", cfg.events.pageView, payload);
  if (window.fbq) window.fbq("track", "PageView");
}

export function trackBookClick(source, extra = {}) {
  trackEvent(cfg.events.ctaBookClick, { source, ...extra });
}

export function trackInnerVoiceClick(source, extra = {}) {
  trackEvent(cfg.events.ctaInnerVoiceClick, { source, ...extra });
}

export function trackOrasisStagingClick(source, extra = {}) {
  trackEvent(cfg.events.ctaOrasisStagingClick, { source, ...extra });
}

window.NbfAnalytics = {
  boot: bootAnalytics,
  track: trackEvent,
  pageView: trackPageView,
  EVENTS: cfg.events,
};
